$(function () {
    let App = window.App;
    App.receiptNotification = {};

    App.receiptNotification.openModal = function (e, modelId) {
        e.preventDefault();

        $.ajax({
            type: 'GET',
            url: '/cart/receipt-notification',
            data: {
                model: modelId,
            },
            dataType: 'json',
            success: function (response) {
                if (response.modal_view) {
                    $('footer').before(response.modal_view);
                    App.modal.open($('#receiptNotificationModal'));
                    window.App.lazyImageLoading();
                }
            }
        });
    }
});